<template>
  <div class="page-wrapper">
    <div class="header-title">
      企业名单
      <el-button 
        v-if="uneditable" 
        type="primary" 
        size="small" 
        style="margin-left: 32px"
        @click="uneditable = false"
      >编辑表单</el-button>
    </div>
    
    <div class="form-wrapper capacity-company-form">
      <div class="tip">注：企业个数建议设置为偶数个，方便大屏展示</div>
      <el-form ref="form" :model="form" label-width="180px">
        <div class="c-row-wrap" v-for="(item, index) in form.companyList" :key="item.key">
          <el-row :gutter="20">
              <el-col :span="1">
                <span class="c-sort-num">{{index + 1}}</span> 
              </el-col>
              <el-col :span="18">
                <el-form-item class="c-form-item-inner"
                  label="企业名称"
                  :prop="'companyList.' + index + '.company'"
                  :rules="[
                    { required: true, message: '请输入企业名称', trigger: 'blur' },
                  ]"
                >
                  <el-input placeholder="请输入企业名称" v-model="item.company" :disabled="uneditable"></el-input>
                </el-form-item>
              </el-col>
              <el-col class="right-handle" :span="2" v-if="!uneditable">
                  <i class="el-icon-remove c-remove" 
                      :class="{'disabled': form.companyList.length === 1}" 
                      :title="form.companyList.length > 1 ? '删除该行': '只有一行，不允许删除'"
                      @click="removeLine('companyList', index)"
                  ></i>
                  <i class="el-icon-circle-plus c-add" title="添加一行"
                      @click="addLine('companyList', index)"
                  ></i>
              </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <div class="bottom-btns-wrap" v-if="!uneditable">
        <el-button class="btn-cancel" @click="cancelEdit">取消</el-button>
        <el-button class="btn-large" type="primary" @click="submitHandle">提交</el-button>
    </div>
  </div>
</template>

<script>
import { nanoid } from 'nanoid'
import { ajaxDatav } from '../../common/request_datav.js'
import { utils } from '../../common/common.js'
export default {
  computed: {
    adminId() {
      return utils.getAdminId()
    },
  },
  data() {
    return {
      uneditable: true,
      form: {
        companyList: [
          // {
          //   id: nanoid(),
          //   company: '', 
          // }
        ]
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 获取列表数据
    getData() {
      ajaxDatav.get('/capacity-dashboard-company/list').then(res => {
        // console.log(res)
        if (res.code === 200) {
          if (res.data && Array.isArray(res.data) && res.data.length > 0) {
            this.form.companyList = res.data.map(item => ({id: item.id, company: item.company}))
          } else {
            this.form.companyList = [
              {
                id: nanoid(),
                company: '', 
              }
            ]
            this.uneditable = false
          }
        } else {
          this.$message.error(res.msg || '获取企业数据失败')
        }
      }).catch(e => {
        console.error(e)
      })
    },
    // 提交数据
    submitData() {
      const loading = this.$loading({
        lock: true,
        text: '正在保存...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let params = this.form.companyList.map(item => ({
        createBy: this.adminId,
        company: item.company
      }))
      ajaxDatav.post('/capacity-dashboard-company/saveBatch', params).then(res => {
        // console.log(res)
        if (res.code === 200) {
          this.$message.success('操作成功')
          this.uneditable = true
          this.getData();
        } else {
          this.$message.error(res.msg || '操作失败')
        }
      }).catch(e => {
        console.error(e)
      }).finally(() => {
        loading.close()
      })
    },
    // 删除一行
    removeLine(key, index) {
        let length = this.form[key].length
        if (length <= 1) return
        this.form[key].splice(index, 1)
    },
    // 添加一行
    addLine(key, index) {
      let item = {
        id: nanoid(),
        company: '',
      }
      this.form[key].splice(index+1, 0, item)
    },
    cancelEdit() {
      this.$confirm('确认取消编辑吗?', '提示', {
          confirmButtonText: '取消编辑',
          cancelButtonText: '继续编辑',
          type: 'warning'
      }).then(() => {
          this.uneditable = true
          this.$refs['form'].clearValidate()
          this.getData();
      })
    },
    submitHandle() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.submitData()
        } 
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  background: #fff;
  padding: 16px;
  padding-bottom: 80px;
  box-sizing: border-box;
  min-height: 100%;
  .header-title {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 16px;
    color: #333;
  }
  .form-wrapper {
    margin: 0 auto;
    width: 800px;
    .tip {
      color: #999;
      font-size: 13px;
      margin-bottom: 12px;
    }
  }
    .c-row-wrap {
      padding: 4px 0;
    }
    .c-sort-num {
      margin-top: 8px;
      display: block;
      width: 20px;
      height: 20px;
      border: 1px solid #999;
      line-height: 20px;
      text-align: center;
      color: #999;
      font-size: 12px;
      border-radius: 50%;
    }
    .right-handle {
      padding-top: 8px;
    }
    .c-remove {
      margin-right: 4px;
      cursor: pointer;
      font-size: 16px;
      &.disabled {
          color: #ccc;
          cursor: no-drop;
      }
    }
    .c-add {
      font-size: 16px;
      cursor: pointer;
    }
    .bottom-btns-wrap {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        box-sizing: border-box;
        padding: 20px 0 20px 0px;
        text-align: center;
        z-index: 1;
        background: #fff;
        box-shadow: 0 -2px 10px #ccc;
        .btn-large {
            padding: 14px 100px;
        }
        .btn-cancel {
            padding-top: 14px;
            padding-bottom: 14px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/capacity/company-list.vue